module.exports = __webpack_public_path__ + "img/resource_mask4.6c91ec1f.png";